import { useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/shop/Seo";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminConfig from "@/pages/admin/AdminConfig";
import { apiSend } from "@/shop/api";

const TABS = [
  { id: "prodotti", label: "Prodotti" },
  { id: "ordini", label: "Ordini" },
  { id: "config", label: "Configurazione" },
];

export default function AdminApp() {
  const [user, setUser] = useState(null);
  const [tab, setTab] = useState("prodotti");

  const login = async (email, password) => {
    const u = await apiSend("/api/auth/login", { email, password });
    setUser({ email: u.email });
    return u;
  };

  const logout = async () => {
    try {
      await apiSend("/api/auth/logout", {});
    } catch {
      /* noop */
    }
    setUser(null);
  };

  if (!user)
    return (
      <AdminLogin onLogin={setUser} login={login} />
    );

  return (
    <div className="bg-ink text-bone min-h-screen" data-testid="admin-app">
      <Seo title="Admin — Stillwater" />
      <header className="border-b border-ink-border px-5 md:px-10 pt-20 md:pt-24 pb-0">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-ember">
              Redazione — pannello
            </p>
            <h1 className="font-serif font-light text-3xl md:text-4xl mt-2">Ciao, {user.email}</h1>
          </div>
          <div className="flex gap-3">
            <Link
              to="/"
              className="font-mono text-[10px] uppercase tracking-[0.25em] border border-ink-border rounded-full px-5 py-2.5 text-mist hover:text-bone transition-colors"
            >
              Il giornale
            </Link>
            <button
              data-testid="admin-logout"
              onClick={logout}
              className="font-mono text-[10px] uppercase tracking-[0.25em] border border-ink-border rounded-full px-5 py-2.5 text-mist hover:text-ember hover:border-ember transition-colors"
            >
              Esci
            </button>
          </div>
        </div>
        <nav className="mt-8 flex gap-1">
          {TABS.map((t) => (
            <button
              key={t.id}
              data-testid={`admin-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`font-mono text-[10px] uppercase tracking-[0.25em] px-5 py-3 border-b-2 -mb-px transition-colors ${
                tab === t.id ? "border-ember text-bone" : "border-transparent text-faint hover:text-mist"
              }`}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </header>
      <main className="px-5 md:px-10 py-10">
        {tab === "prodotti" && <AdminProducts />}
        {tab === "ordini" && <AdminOrders />}
        {tab === "config" && <AdminConfig />}
      </main>
    </div>
  );
}

function AdminLogin({ onLogin, login }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const u = await login(email, password);
      onLogin({ email: u.email });
    } catch (ex) {
      setErr(ex.data?.detail || "Credenziali non valide");
      setLoading(false);
    }
  };

  return (
    <div className="bg-ink text-bone min-h-screen flex items-center justify-center px-5" data-testid="admin-login">
      <Seo title="Admin — Stillwater" />
      <form onSubmit={submit} className="w-full max-w-sm border border-ink-border bg-ink-surface p-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-ember">Redazione</p>
        <h1 className="mt-3 font-serif font-light text-3xl">Accesso</h1>
        <input
          data-testid="admin-email"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-8 w-full bg-ink border border-ink-border rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-ember"
        />
        <input
          data-testid="admin-password"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-3 w-full bg-ink border border-ink-border rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-ember"
        />
        {err && <p className="mt-3 text-xs text-ember" data-testid="admin-error">{err}</p>}
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="mt-6 w-full bg-ember text-ink font-mono text-[11px] uppercase tracking-[0.25em] py-3.5 rounded-full hover:bg-ember-bright transition-colors disabled:opacity-50"
        >
          {loading ? "Accesso…" : "Entra"}
        </button>
        <Link to="/" className="block mt-5 text-center font-mono text-[9px] uppercase tracking-[0.25em] text-faint hover:text-mist">
          ← Il giornale
        </Link>
      </form>
    </div>
  );
}
